import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

const billSmootherSlice = createSlice({
  name: "billSmootherConfig",
  initialState: {
    billSmootherConfig: undefined,
  },
  reducers: {
    setBillSmootherConfig: (
      state,
      action: PayloadAction<{
        billSmootherConfig: BillSmootherConfig;
      }>,
    ) => {
      state.billSmootherConfig = action.payload.billSmootherConfig;
    },
  },
});

export const { setBillSmootherConfig } = billSmootherSlice.actions;
export const billSmootherSliceReducer = billSmootherSlice.reducer;
